import { Company } from 'module/api/company/types';
import { Image } from 'antd';
import { FC } from 'react';

interface CompanyLogoProps {
  data: Pick<Company, 'companyLogoUrl' | 'companyName'>;
}
export const CompanyLogo: FC<React.PropsWithChildren<CompanyLogoProps>> = ({
  data,
}) => (
  <Image
    width={64}
    height={64}
    src={data.companyLogoUrl}
    preview={false}
    title={data.companyName}
    alt={data.companyName}
  />
);
